<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { useBtnMore } from '@composables/widgets/menu/btn-more.hook'

import { HOME_TOUR_STEPS } from '@config/feature-tour/home-product-onboarding'

import HeaderNavItem from '@Molecules/HeaderNavItem.vue'
import DropdownMore from '@Widgets/Menu/DropdownMore.vue'
import FeatureTourSpot from '@Molecules/FeatureTour/FeatureTourSpot.vue'

defineOptions({
  name: 'BtnMore',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const route = useRoute()

const {
  disabled,
  selected,
  isNew,
  pointer,
} = useBtnMore({ route })
</script>

<template>
  <FeatureTourSpot :id="HOME_TOUR_STEPS.BTN_MORE">
    <HeaderNavItem
      :layout="layout"
      icon="circle-ellipsis"
      label="More"
      :selected="selected"
      :disabled="disabled"
      :indicator="isNew ? { view: 'new' } : undefined"
      :pointer="pointer && !isNew"
    >
      <template #menu>
        <DropdownMore />
      </template>
    </HeaderNavItem>
  </FeatureTourSpot>
</template>
